import { render, staticRenderFns } from "./IaqfazIntegration.vue?vue&type=template&id=3bda5177&scoped=true&"
import script from "./IaqfazIntegration.vue?vue&type=script&lang=js&"
export * from "./IaqfazIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda5177",
  null
  
)

export default component.exports